import { aiChatBot, aiConfiguration, apps } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { IAIConfiguration, IApiKeyConfigurationIndexData } from "../../models/ai/IAI";
import { urlBinder } from "../../helper/url-binder";
import { ISessionDetail } from "../../models/common/IChatBot";

export default new (class AIConfigurationService {
  public createApiKeyConfiguration = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = aiConfiguration.CREATE_API_KEY_CONFIGURATION;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public getApiKeyConfiguration = async (
    id: number
  ): Promise<IApiResponse<IAIConfiguration>> => {
    try {
      let endPoint = urlBinder(aiConfiguration.GET_API_KEY_CONFIGURATION, [
        `${id}`,
      ]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IAIConfiguration>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IAIConfiguration>;
      } else {
        throw error;
      }
    }
  };

  public getApiConfigurations = async (collegeId?: number): Promise<
    IApiResponse<Array<IApiKeyConfigurationIndexData>>
  > => {
    try {
      let endPoint = urlBinder(aiConfiguration.GET_ALL_API_KEY_CONFIGURATION,[collegeId]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<
        Array<IApiKeyConfigurationIndexData>
      >;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<
          Array<IApiKeyConfigurationIndexData>
        >;
      } else {
        throw error;
      }
    }
  };

    public updateApiKeyConfiguration = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(aiConfiguration.UPDATE_API_KEY_CONFIGURATION, [
        `${id}`,
      ]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteApiKeyConfiguration = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(aiConfiguration.DELETE_API_KEY_CONFIGURATION, [
        `${id}`,
      ]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };

  public getAIPreviousChatMessages = async (limit: number): Promise<
    IApiResponse<string[]>
  > => {
    try {
      var endPoint = urlBinder(aiChatBot.GET_PREVIOUS_CHAT_MESSAGES, [limit]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<string[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<string[]>;
      } else {
        throw error;
      }
    }
  };

  public updateAISessions = async (
  ): Promise<IApiResponse<boolean>> => {
    try {
      const response = await APIService.put(aiChatBot.UPDATE_AI_CHAT_SESSIONS);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public getAiAgentKey = async (): Promise<IApiResponse<string>> => {
    try {
      const response = await APIService.get(aiChatBot.GET_AI_AGENT_KEY);
      return response.data as IApiResponse<string>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<string>;
      } else {
        throw error;
      }
    }
  };

  public getSessionMessages = async (
    sessionId: number,
  ): Promise<IApiResponse<ISessionDetail>> => {
    try {
      const response = await APIService.get(
        `${aiChatBot.GET_SESSION_MESSAGES}?sessionId=${sessionId}`,
      );
      return response.data as IApiResponse<ISessionDetail>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<ISessionDetail>;
      } else {
        throw error;
      }
    }
  };
})();

